<div style="height: 80px;" *ngIf="isYearsPage && currentYear !== null" class="year-nav">
    <a *ngIf="currentYear > 2015" [routerLink]="['/Years', currentYear - 1]">
        &laquo; {{ currentYear - 1 }}
    </a>

    &nbsp; | | &nbsp;

    <a *ngIf="currentYear < todayYear" [routerLink]="['/Years', currentYear + 1]">
        {{ currentYear + 1 }} &raquo;
    </a>
</div>


<div class="search-results" infinite-scroll (scrolled)="onScrollDown($event)">

    <ng-template #artBox></ng-template>
    <!--      <div class="list-group">-->
    <!--        <a class="list-group-item list-group-item-action" *ngFor="let i of listArray">-->
    <!--          <p class="mb-1">{{i}} Item added on {{direction}}</p>-->
    <!--        </a>-->
    <!--      </div>-->

</div>


<div *ngIf="isYearsPage && currentYear !== null" class="year-nav">
    <a *ngIf="currentYear > 2015" [routerLink]="['/Years', currentYear - 1]">
        &laquo; {{ currentYear - 1 }}
    </a>

    &nbsp; | | &nbsp;

    <a *ngIf="currentYear < todayYear" [routerLink]="['/Years', currentYear + 1]">
        {{ currentYear + 1 }} &raquo;
    </a>
</div>